import { graphql } from '@api/generated';

export const GET_SECOND_CHANCE_LEAD_CALL_FOLLOW_UPS_COUNT_QUERY = graphql(`
  query secondChanceLeadsCount($filter: SecondChanceLeadFollowUpFilterInput) {
    secondChanceLeadFollowUps(filter: $filter) {
      totalCount
    }
  }
`);
